import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    accordionSummaryClasses,
    styled,
} from '@mui/material';
import type { ComponentProps, ReactNode } from 'react';

type AccordionProps = ComponentProps<typeof Accordion> & {
    summary: ReactNode;
    expandButton?: ReactNode;
};
const AccordionSummaryStyled = styled(AccordionSummary)({
    [`& .${accordionSummaryClasses.content}`]: {
        margin: '0 !important',
    },
});
const AccordionDetailsStyled = styled(AccordionDetails)(({ theme }) => ({
    padding: '0px 45px 16px',
    [theme.breakpoints.up('sm')]: {
        padding: '0px 60px 16px',
    },
}));

export default function AccordionLayout({
    summary,
    children,
    expandButton,
    ...otherProps
}: AccordionProps) {
    return (
        <Accordion {...otherProps}>
            <AccordionSummaryStyled expandIcon={expandButton}>
                {summary}
            </AccordionSummaryStyled>
            <AccordionDetailsStyled>{children}</AccordionDetailsStyled>
        </Accordion>
    );
}
